import { ProcessingMetrics } from '../../model/metrics/ProcessingMetrics';
import { Factory } from '../Factory';
import { BaseProcessingMetricsService } from './BaseProcessingMetricsService';
import { IConfigService } from '../config';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class PreProcessingMetricsService extends BaseProcessingMetricsService {
  private allProjectMetrics;
  private allCollectionMetrics;

  constructor($resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
    super($resource, configService, resourceWrapperService);

    let baseUrl = configService.getServerBaseUrlForResource();
    this.allProjectMetrics = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/preprocessingmetrics`, {id: "@id"}, {
      query: {
        method: "GET",
        isArray: false
      }
    }));
    this.allCollectionMetrics = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/preprocessingmetrics`, {
      id: "@id",
      collectionId: "@collectionId"
    }, {query: {method: "GET", isArray: false}}));

    this.projectMetricsByExtension = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/preprocessingmetrics/extension/size`, {id: "@id"})),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/preprocessingmetrics/extension/count`, {id: "@id"})),
      this.resourceWrapperService
    );

    this.projectMetricsByType = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/preprocessingmetrics/type/size`, {id: "@id"})),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/preprocessingmetrics/type/count`, {id: "@id"})),
      this.resourceWrapperService
    );

    this.collectionMetricsByExtension = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/preprocessingmetrics/extension/size`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/preprocessingmetrics/extension/count`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService
    );

    this.collectionMetricsByType = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/preprocessingmetrics/type/size`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/preprocessingmetrics/type/count`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService
    );
  }

  public GetAllMetrics(projectId: string, collectionId?: string) {
    return collectionId ? this.allCollectionMetrics.query({
      id: projectId,
      collectionId: collectionId,
    }).$promise : this.allProjectMetrics.query({id: projectId}).$promise;
  }
}

frontendApp.factory("PreProcessingMetricsService", ['$resource', 'ConfigService', 'ResourceWrapperService', function(resource, configService, resourceWrapperService) {
  return new PreProcessingMetricsService(resource, configService, resourceWrapperService);
}]);
